//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios"
import xcomment from '../components/xcomment.vue'
import $ from 'jquery'

export default {
    components: {
        xcomment
    },
    data() {
        return {
            data: null,
            word: ['关注', '已关注'],
            num: 0,
            newCommentCount: [],
            height:''
        }
    },
    updated() {
        // 生命周期，在updated才会更新
        //window.scrollTo(0, 200);
        var height = JSON.parse(com.getCookie('height'));
        for(var i = 0;i<height.length;i++){
        	if(height[i].id == this.$store.state.commentNum){
        		window.scrollTo(0,height[i].height);
        	}
        }
    	//window.scrollTo(0,300);
    },
    mounted() {
        var id = this.$route.params.id * 1;
        console.log(this.isShowContainer);
        var self = this;
        axios.get('../static/data/passage.json')
            .then(function(response) {
                self.data = response.data.RECORDS[9-id];
                self.$store.state.commentNum = self.data.id;
                console.log(self.data);
            })
            .catch(function(error) {
                console.log(error);
            });
    },
    methods: {
        focusStatus(num) {
            if (this.num == 0) {
                this.num = 1
            } else {
                this.num = 0;
            }
        },
        showInput() {
            this.isShowInput = true;
        },
        watchComment() {
            this.$store.state.showComment = true;
            this.$store.state.isShowContainer = false;
            //this.isShowContainer = this.$store.state.isShowContainer;
        },
        historyHight() {
        	var obj = {"id":this.data.id,"height":window.scrollY};
        	this.$store.state.arrHight.push(obj);
        	com.setCookie('height',JSON.stringify(this.$store.state.arrHight));
        }
    },
    computed: {
        isShowContainer() {
            return this.$store.state.isShowContainer
        },
        /*newCommentCount() {
            return this.$store.state.newCommentCount
        }*/
    }
}



// WEBPACK FOOTER //
// ./src/views/passageDetail.vue